import 'css/desktop/post-display.scss';

import 'js/desktop/common/common.jquery.js';
import 'js/plugin/jquery-facebook-sdk/facebook-sdk.jquery.js';
import 'js/plugin/jquery-facebook-sdk/facebook-page-plugin.jquery.js';
import 'js/plugin/jquery-facebook-sdk/facebook-video.jquery.js';
import 'js/plugin/jquery-facebook-sdk/facebook-comments.jquery.js';
import 'js/plugin/share-bar.jquery.js';
import 'js/plugin/newsletter-form/newsletter-form.jquery.js';

/**
 * Load and initializes the Facebook SDK.
 * When the script is loaded,
 * renders a Page Plugin and the Comments
 */
$(document).fbSDK()
	.on('fbSDK:load', function () {
		$('.post__fb-page-plugin').fbPagePlugin({
			autoRender: false
		});

		$('[data-fb-video]').fbVideo();

		if ($(document).data('plugin_fbSDK').options.appId) {
			$('.post__fb-comments').fbComments();
		}
	});

/**
 * Load Open Graph data for fbComments and shareBar
 */
$.fbSDK.fetchGraphData();


$(document).ready(function () {
	/**
	 * Init the share bar
	 */
	$('.post__share-bar').shareBar();

	/**
	 * Style Instagram embeds
	 */
	$('.instagram-media')
		.closest('.featured-video')
		.css('background', '#fff');

	/**
	 * Style Twitter embeds
	 */
	$('.twitter-tweet')
		.closest('.featured-video')
		.css({
			'display': 'flex',
			'justify-content': 'center',
			'background': 'none'
		});

	/**
	* Resize embeded video to fit containr
	*/
	$('.featured-video').on('load', 'iframe', function () {
		var $iframe = $(this);

		$iframe.css({ margin: 0 });
	});

	if (COPYRIGHT_PROTECTION.enabled) {
		$('.post__description').on('copy', function (e) {
			e.stopPropagation();
			e.preventDefault();

			var data = '';
			data += $('.post__title').text() + '\r\n\r\n';
			data += 'Leia mais: ' + $('link[rel="canonical"]').attr("href") + '\r\n\r\n';

			if (COPYRIGHT_PROTECTION.message) {
				data += COPYRIGHT_PROTECTION.message;
			}

			e.originalEvent.clipboardData.setData('text/plain', data);
		});
	}

	/**
	* DISQUS CONFIG
	*/
	if ($('#disqus_thread')[0]) {
		window.disqus_config = function () {
			this.page.url = $('link[rel="canonical"]').attr('href'); // Replace PAGE_URL with your page's canonical URL variable
			var id = this.page.url.match(/\/noticias\/(\d*?)\//)[1];
			this.page.identifier = '#' + id; // Replace PAGE_IDENTIFIER with your page's unique identifier variable
		};

		(function () {
			var d = document, s = d.createElement('script');
			s.src = 'https://jornal-da-cidade-online.disqus.com/embed.js';
			s.setAttribute('data-timestamp', +new Date());
			(d.head || d.body).appendChild(s);
		})();
	}

	//$.getScript('https://widgets.outbrain.com/outbrain.js');
	$.getScript('https://platform.twitter.com/widgets.js');
});
